import formatAmountWithCurrency from '@format/priceWithCurrency';
import { Currency } from '@/typings/api-models';

function getNormalisedCurrencyValue(value: string | number | null | undefined, currency: Currency): string {
  if(value === null || value === undefined) return "--";
  if(typeof value === 'number') return formatAmountWithCurrency(value, currency);
  if(typeof value === 'string') return Number.isNaN(Number(value)) ? "--" : formatAmountWithCurrency(Number(value), currency);
  return '--';
}

export default getNormalisedCurrencyValue;